import BaseModel from '../../../base';

import constants from './constants';

export default class EventRecommendationWeight extends BaseModel {
  constructor(item, url) {
    super(item, url);

    this.description = item.description;
    this.formula = item.formula;

    this.factors = item.factors;
    this.settings = item.settings;
  }

  static get constants() {
    return constants;
  }
}
